<script>
export default {
  name: 'Checkbox',
  props: {
    isCorrect: Boolean,
    label: String,
    img: String,
  },
  data: () => ({
    isSelected: false
  }),
  mounted() { },
  methods: {
    onClick: function(event) {
      event.preventDefault();
      if (!this.isSelected) {
        this.$emit('clicked', event);
        this.isSelected = !this.isSelected;
      }
    }
  }
};
</script>

<template>
  <div class="checkbox" v-bind:class="{'checkbox--correct': isCorrect, 'checkbox--selected': isSelected}" v-on:click="onClick($event)">
    <div class="checkbox__control" v-bind:style="{ backgroundImage: 'url(' + img + ')' }">
      <input class="checkbox__input" type="checkbox"  v-on:click="onClick">
    </div>
    <label class="checkbox__label">{{ label }}</label>
  </div>
</template>

<style lang="scss" scoped>

$borderWidth: .5625rem;
$checkboxDimension: 7.5rem;
$borderLength: ($checkboxDimension * .5);

.checkbox {
  position: relative;
  width: $checkboxDimension;
  text-align: center;
}

.checkbox__control {
  display: inline-block;
  height: $checkboxDimension; width: $checkboxDimension;
  border-radius: 50%;
  background-color: var(--light);
  background-size: cover;
  background-position: center;
  overflow: hidden;
  transition: filter 500ms linear 100ms;
}

.checkbox__control:before {
  content: "";
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: var(--dark);
  opacity: 0;
  transition: opacity 500ms linear 100ms;
}

.checkbox--selected .checkbox__control:before {
  opacity: .6;
}

.checkbox--selected .checkbox__control {
  filter: grayscale(100%);
}

.checkbox__input {
  display: inline-block;
  position: relative;
  background-color: transparent;
  height: 100%; width: 100%;
  border: $borderWidth solid transparent;
  border-radius: 50%;
  margin: 0;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  appearance: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  transform: rotate(-45deg);
}

.checkbox__input::before,
.checkbox__input::after {
  content: "";
  position: absolute;
  top: 50%; left: 50%;
  background: var(--light);
  border-radius: .0625rem;
  transition: transform 400ms 200ms cubic-bezier(0.23, 1, 0.32, 1);
}

.checkbox__input::before {
  width: $borderWidth; height: $borderLength;
  margin: ($borderLength / -2) ($borderWidth / -2);
  transform: translateY(($checkboxDimension * 1.5));
}

.checkbox__input::after {
  height: $borderWidth; width: $borderLength;
  margin: ($borderWidth / -2) ($borderLength / -2) ;
  transform: translateX(($checkboxDimension * 1.5));
}

.checkbox--selected .checkbox__input::before,
.checkbox--selected .checkbox__input::after {
  transform: translate(0, 0);
}

.checkbox--correct {
  .checkbox__input::before,
  .checkbox__input::after {
    top: 54%; left: 50%;
  }

  .checkbox__input::before {
    width: $borderWidth; height: ($borderLength * 0.51);
    margin: ($borderLength / -2.3) (($borderLength / -2.3));
  }

  .checkbox__input::after {
    height: $borderWidth; width: $borderLength;
    margin: ($borderWidth / -2.3) ($borderLength / -2.3) ;
  }
}

.checkbox__label {
  display: block;
  height: 2.625rem;
  margin: .35rem 0;
  font-size: 1.1rem;
  line-height: 1.2;
  font-family: var(--font-family-secondary);
  overflow: hidden;
}

</style>